<template>
  <div class="list" style="padding: 1.5rem 0.65rem 0.5rem 0.65rem; text-align: left;">
    <el-collapse v-if="0 < totalItems">
      <el-collapse-item 
        v-for="(fData,tIdx) in docRecordList" 
        :key="'F'+tIdx" :index="tIdx" :name="'F'+tIdx">
        <template slot="title">
          <span style="font-size: large; font-weight: bolder;color:#141e1b;">{{fData.text}}&nbsp;<i class="el-icon-view"></i></span>
        </template>
        <el-collapse style="padding: 0.5em 1em;">
          <el-collapse-item 
            v-for="(subData,subIdx) in fData.data" 
            :key="'S'+subIdx" :index="subIdx" :name="'S'+subIdx">
            <template slot="title">
              <span style="font-size: larger; font-weight: bolder; color:#132c33;">{{subIdx+1}}∙&nbsp;{{subData.text}}&nbsp;<i class="el-icon-thumb"></i></span>
            </template>
            <table class="table" style="border-collapse:collapse; border:solid windowtext 1.0pt; margin: 0 1.25em;" rules="all"
              v-if="(null != subData.data) && (0 < subData.data.length)">
              <thead>
                <tr>
                  <th class="th-title" style="width: 2.5em;">序號</th> 
                  <!-- <th class="th-title" style="width: 15em;">類別</th>  -->
                  <th class="th-title" style="width: 16em;">主題</th> 
                  <th class="th-title" style="width: 12em;">學校</th> 
                  <th class="th-title" style="width: 9em;">科系</th> 
                  <th class="th-title" style="width: 5em;"
                    v-for="tIdx in fData.tecLen" :key="'T0'+tIdx" :index="tIdx" :name="'T0'+tIdx">
                    指導老師{{tIdx}}
                  </th> 
                  <th class="th-title" style="width: 5em;"
                    v-for="sIdx in fData.studLen" :key="'S0'+sIdx" :index="sIdx" :name="'S0'+sIdx">
                    參賽學生{{sIdx}}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in subData.data" :key="item.fId" :index="item.fId" :name="item.fId">
                  <td class="td-text" style="width: 2.5em; text-align: center;">{{index+1}}</td>
                  <!-- <td class="td-text">{{item.typeStr}}</td> -->
                  <td class="td-text" style="width: 16em;">{{item.title}}</td>
                  <td class="td-text" style="width: 12em;">{{item.schName}}</td>
                  <td class="td-text" style="width: 9em;">{{item.division}}</td>
                  <td class="td-text" style="width: 5em;"
                    v-for="tdIdx in fData.tecLen"
                    :key="'T1'+tdIdx">
                    {{(item.guide!=null && item.guide.length>=tdIdx? item.guide[tdIdx-1].name:'')}}
                  </td>
                  <td class="td-text" style="width: 5em;"
                    v-for="sdIdx in fData.studLen"
                    :key="'S1'+sdIdx">
                    {{(item.student!=null && item.student.length>=sdIdx? item.student[sdIdx-1].name:'')}}
                  </td>
                </tr>
              </tbody>
            </table>
          </el-collapse-item>
        </el-collapse>
      </el-collapse-item>
    </el-collapse>
    <div v-else>無相關資料~</div>
  </div>
</template>

<script>
import * as tools from '../tool';
export default {
  name: 'list',
  data () {
    return {
      docRecordList: [],
      totalItems: 0,
      sLen: 0,
      tLen: 0
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
  },
  methods: {
    query() {
      var vm = this;
      this.docRecordList = null;
      this.totalItems = 0;
      this.$http.get('./WebApi/Apply/GetListDataV2/'.concat(this.sysId).concat("/").concat(this.setting.enrollID[0].codeName).concat("/2/1"))
                .then((response) => {
                  if (!tools.isNull(response.data)) { 
                    vm.docRecordList = response.data;
                    vm.totalItems = vm.docRecordList.length;
                  }
                })
                .catch(function (error) {
                  vm.$message.error('對不起,網路連線失敗' + error)
                }) 
    }
  },
  created () {
    console.log('======ListViewV2=====');
    this.query();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.th-title {
  font-size: smaller;
  text-align: center;
  line-height: 1.75rem;
  font-weight: bold;
}
.td-text {
  line-height: 1.75rem;
  word-break: break-all;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
.el-collapse-item__header {
  padding: 18px 20px;
  border-bottom: 1px solid #ebeef5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: large;
  font-weight: bolder;
} 
</style>



// WEBPACK FOOTER //
// src/components/ListViewV2.vue